import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { ApiErrorFactory } from '../../core/api-errors';
import { SftpKeyService } from '../../core/sftp';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
@Component({
  selector: 'app-delete-dialog',
  template: `
    <div class="delete-key-dialog delete-key-container">
      <mat-card-header>
        <mat-card-title>{{ 'PAGES.SFTP.DELETE_KEY_MODAL.TITLE' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (showConfirmMsg) {
          <p>
            {{ 'PAGES.SFTP.DELETE_KEY_MODAL.DESCRIPTION' | translate: { key: keyName } }}
          </p>
        } @else {
          <p>{{ 'PAGES.SFTP.DELETE_KEY_MODAL.MESSAGE' | translate }}</p>
        }
      </mat-card-content>
      <mat-card-actions layout-align="end right">
        <button
          type="button"
          mat-raised-button
          color="accent"
          class="confirm-button"
          [disabled]="disableButton"
          (click)="onOKClick()"
          >
          {{ 'PAGES.SFTP.DELETE_KEY_MODAL.BUTTONS.OK' | translate }}
        </button>
        <button
          type="button"
          mat-button
          color="accent"
          class="confirm-button"
          [disabled]="disableButton"
          (click)="onCancelClick()"
          >
          {{ 'PAGES.SFTP.BUTTONS.CANCEL' | translate }}
        </button>
        @if (disableButton) {
          <mat-spinner
            class="info-spinner-small"
            color="accent"
            [diameter]="30"
            [strokeWidth]="4"
          ></mat-spinner>
        }
      </mat-card-actions>
    </div>
    
    `,
  styleUrls: [`./delete-key.styles.scss`],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DeleteKeyDialogComponent {
  public keyName: string;
  public showConfirmMsg = true;
  public disableButton = false;

  constructor(
    public dialogRef: MatDialogRef<DeleteKeyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private keyService: SftpKeyService,
    private alertService: SnackbarService,
    private apiErrorFactory: ApiErrorFactory,
    private translateService: TranslateService,
    public readonly analyticsService: ProductAnalyticsService,
  ) {
    this.keyName = data.keyName;
  }

  onOKClick(): void {
    this.showConfirmMsg = false;
    this.disableButton = true;
    this.analyticsService.trackEvent('sftp:delete-key', 'delete-sftp-key', 'clicked');

    this.keyService.remove(this.keyName).subscribe(
      () => {
        this.dialogRef.close(true);
      },
      (err) => {
        const parsedError = this.apiErrorFactory.parseErrorResponse(err);
        this.alertService.openErrorSnack(
          parsedError.getUserMessage(),
          this.translateService.instant('ALERTS.GENERAL.DISMISS'),
        );
        this.dialogRef.close(false);
      },
    );
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }
}
